if( ! document.getElementById("view-order-job") ) {
   return;
}

const jobElement = document.getElementById('view-order-job');
const modal = document.querySelector('.custom-message-modal-overlay');
const modalTitle = document.querySelector('.custom-message-modal-title');
const modalBodyText = document.querySelector('.custom-message-modal-body');
const modalFooter = document.querySelector('.custom-message-modal-footer');
const modalTriggerBtn = document.querySelector('.open-modal-btn');
const modalCross = document.querySelector('.custom-message-modal-close');
const modalElement = document.querySelector('.custom-message-modal-overlay');

const confirmUpdate = document.querySelector('.custom-message-modal-btn.confirm');
const confirmBtnCancel = document.querySelector('.custom-message-modal-btn.btn-delete.cancel');

function jobActionModal(message, title='Attention Required') {
	if (modalTitle) modalTitle.innerHTML = title;
	if (modalBodyText) modalBodyText.innerHTML = '';
	if (modalBodyText) modalBodyText.innerHTML = message;

	if( modalCross ) modalCross.style.display = 'none';
	
	// Show modal
	if (modalTriggerBtn) modalTriggerBtn.click();
}

confirmUpdate.addEventListener("click", function(event) {
	if( modalElement ) modalElement.classList.add('processing');
	const jobId = jobElement.getAttribute('data-job');
	const quantity = jobElement.getAttribute('data-quantity');
	const action = confirmUpdate.getAttribute('data-action');
	let actionLabel = action.charAt(0).toUpperCase() + action.slice(1);

	confirmUpdate.style.display = 'none';
	confirmBtnCancel.style.display = 'none';
	// jobActionModal(`Attempting to ${actionLabel} Ad for 1 week...`, 'Please wait');
	jobActionModal(`Attempting to ${actionLabel} Ad for ${quantity} week...`, 'Please wait');
	
	const formData = new FormData();
	formData.append('job', jobId);
	formData.append('job_action', action);
	formData.append('job_quantity', quantity);

	formData.append('action', 'employer_job_ad_action');
	formData.append('nonce', ajax_callback_data.ajax_nonce);

	fetch(ajax_callback_data.ajax_url, {
		method: 'POST',
		body: formData
	})
	.then(response => response.json())
	.then(data => {
		console.log(data)
		if( data.success ) {
			window.location.href = data.data.redirect_url;
		} else {
			// if( modalCross ) modalCross.click();
			if( modalCross ) modalCross.style.display = 'block';
		}
	})
	.catch(error => {
		console.error('Error:', error);
		jobActionModal('<p>Something went wrong. Try again.</p>');
	if( modalElement ) modalElement.classList.remove('processing');
	});
});

function incrDecrText(textWord) {
	let output = '';
	output = `<p>${textWord} for <span class="decr">-</span><span class="qty">1</span><span class="incr">+</span> week</p>`;
	// output = '';
	return output;
}

const jobRenew = document.querySelector(".job-renew");
const jobExtend = document.querySelector(".job-extend");
if( jobRenew ) {
	jobRenew.addEventListener("click", function(event) {
		event.preventDefault();
		console.log('renew');
		confirmUpdate.setAttribute('data-action', 'renew');
		const inrDcr = incrDecrText('Renew');
		const renewText = `<p>Are you sure you want to renew Ad upto 1 week?</p>`;
		jobActionModal(`${renewText}${inrDcr}`, 'Confirmation');
		// if (modalTitle) modalTitle.innerHTML = 'Confirmation';
		// if (modalBodyText) modalBodyText.innerHTML = '<p>Are you sure you want to renew the Ad upto 1 week ?</p>';
	});
}

if( jobExtend ) {
	jobExtend.addEventListener("click", function(event) {
		event.preventDefault();
		console.log('extend');
		confirmUpdate.setAttribute('data-action', 'renew');
		const inrDcr = incrDecrText('Extend');
		const extendText = `<p>Are you sure you want to extend Ad for 1 week?</p>`;
		jobActionModal(`${extendText}${inrDcr}`, 'Confirmation');
		// if (modalTitle) modalTitle.innerHTML = 'Confirmation';
		// if (modalBodyText) modalBodyText.innerHTML = '<p>Are you sure you want to extend the Ad for 1 week ?</p>';
	});
}

document.addEventListener("click", function(event) {
    if (event.target.matches(".custom-message-modal .incr")) {
        let qtyEl = event.target.closest("p").querySelector(".qty");
        let qty = parseInt(qtyEl.textContent, 10);

        if (qty < 8) {
            qty++;
            qtyEl.textContent = qty;
			jobElement.setAttribute('data-quantity', qty);
        }
    }

    if (event.target.matches(".custom-message-modal .decr")) {
        let qtyEl = event.target.closest("p").querySelector(".qty");
        let qty = parseInt(qtyEl.textContent, 10);

        if (qty > 1) {
            qty--;
            qtyEl.textContent = qty;
			jobElement.setAttribute('data-quantity', qty);
        }
    }
});
